// Central business / entity facts used in JSON-LD across the site.
// Update here once → reflects everywhere (Seo component + pre-render script).

export const BUSINESS = {
  name: "EquiSight",
  legalName: "SaFleu Equestrian Centre BV",
  url: "https://equisight.nl",
  logo: "https://equisight.nl/assets/logo-square.png",
  email: "support@equisight.nl",
  foundingDate: "2026",
  founder: {
    name: "Martijn Wirken",
    type: "Person",
  },
  vatID: "NL868000164B01",
  kvk: "97318159",
  address: {
    streetAddress: "Kerklaan 7B",
    postalCode: "4944 VA",
    addressLocality: "Raamsdonk",
    addressCountry: "NL",
  },
  geo: {
    // Approximate coordinates for Raamsdonk, NL
    latitude: 51.6917,
    longitude: 4.9028,
  },
  sameAs: ["https://www.instagram.com/equi.sight/"],
  areaServed: ["NL", "BE", "DE"],
  knowsAbout: [
    "Paarden management",
    "Paardengezondheid",
    "Dressuur protocol analyse",
    "Wedstrijdanalyse",
    "Hoefsmid software",
    "Manege software",
    "Fokkerij management",
    "Paardenvoeding",
    "Vaccinaties paard",
    "Ontworming paard",
    "KNHS wedstrijden",
    "FEI wedstrijden",
  ],
  description:
    "EquiSight is een Nederlandse paarden management app voor eigenaren, manegeruiters, trainers en professionals. Beheer gezondheid, training, voeding, planning, wedstrijdanalyse en samenwerking in één paardendossier.",
  slogan: "Insight in every stride.",
  priceRange: "€0–€24,99 per maand",
  paymentAccepted: ["Credit Card", "iDEAL", "SEPA Direct Debit"],
};

export default BUSINESS;
